import React, { Component } from 'react'

import Modal from './Modal'

import Backend from '../../../utils/Backend'

export default class CategoryMenuModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: props.show,
    }
  }

  static getDerivedStateFromProps(nextProps, state) {
    return nextProps
  }

  _save(){
    let { name, filter } = this.state

    let category = null
    this.setState({ loading: true })
    Backend.addCategory({ name })
    .then(response => {
      category = response
      let data = {
        name: filter.name,
        key: filter.key,
        type: "in_category",
        data: filter.data,
        category: category.id
      }
      return Backend.addFilterToCategory(data)
    })
    .then(() => {
      this.setState({ loading: false })
      this.props.onAdded(category)
    })
    .catch(error => {
      alert(error.message)
      this.setState({ loading: false })
    })
  }

  render() {
    let { name, loading } = this.state
    return (
      <Modal
        className="p-category add-name"
        show={this.state.show}
        onHide={() => {
          this.props.onHide()
        }}
      >
        <div>
          <div className="title">Add Name</div>
          <input
            type="text"
            className="form-control"
            onChange={e => this.setState({ name: e.target.value || null })}
          />
          <button
            type="button"
            className="btn btn-warning"
            disabled={loading || !name}
            onClick={() => this._save()}
          >
            Done
          </button>
        </div>
      </Modal>
    )
  }
}
